import { render, staticRenderFns } from "./AddInventory.vue?vue&type=template&id=7fb15af3&"
import script from "./AddInventory.vue?vue&type=script&lang=js&"
export * from "./AddInventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports